/* eslint-disable react-hooks/exhaustive-deps */
// import React, { useState } from "react";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { removeToken } from "../utilities/authHelper";

const Logout = ({ onLogout = () => {} }) => {
  const navigate = useNavigate();

  useEffect(() => {
    removeToken(() => {
      onLogout();
      navigate("/login", { replace: true });
    });
  }, [navigate, onLogout]);
};
export default Logout;
